import VuexPersist from 'vuex-persist'
import * as mutationTypes from '@/store/mutation-types'
import { StorageKey } from '@/util/functions/StorageKey'
import { S4 } from '@/util/functions/S4'

const parts = window.location.pathname.split('/')

const getSessionRequestCode = () => {
  return S4.getItem(StorageKey.RESERVED)?.codeVersion?.requestCode
}

// getSessionRequestCode == the request code (which we will use to create a unique key for local storage) saved to sessionStorage.
// parts[3] == the request code as path param, use this if no code is saved to sessionStorage.
// reducer: reduces the saved state down to just what you want to save
const vuexLocalStorage = new VuexPersist({
  key: getSessionRequestCode() || parts[3],
  storage: window.localStorage,
  reducer: ({ cart, orderConfirmation, recipientData, feedback }) => ({
    cart,
    orderConfirmation,
    recipientData,
    feedback
  }),
  // don't want to persist show cart to localstorage or menu will be open (and oddly positioned) on reload
  filter: mutation => mutation.type !== mutationTypes.SET_SHOW_CART
})

// Mutations that should result in session storage being updated
const sessionStorageMutations = [
  mutationTypes.SET_DIRECT_PAYMENT_AMOUNT,
  mutationTypes.SET_DIRECT_PAYMENT_TYPE,
  mutationTypes.SET_DIRECT_PAYMENT_UTID
]

// Plugin for saving session specific information to session storage so that it persists across page refreshes
const vuexSessionStorage = new VuexPersist({
  key: 'rewardlink',
  storage: window.sessionStorage,
  reducer: ({ directPayment }) => ({
    directPayment
  }),
  filter: ({ type }) => sessionStorageMutations.includes(type)
})

export { vuexLocalStorage, vuexSessionStorage }
